import { useIntl } from "gatsby-plugin-intl";
import React from "react"
import { Helmet } from 'react-helmet'

export default () => {
    const intl = useIntl();
    const lang = intl.locale;
    const title = intl.formatMessage({ id: `app.subtitle` });
    return (
        <Helmet htmlAttributes={{
            lang
        }}>
            <title>{title}</title>
            <link rel="preload" href="https://use.typekit.net/wpt1tdj.css" as="style" onload="this.onload=null;this.rel='stylesheet'"/>
        </Helmet>
    )
}